/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type HoldUpgradeOperationEnum = 'PUT_ON_HOLD' | 'CLEAR_ON_HOLD';

export const HoldUpgradeOperationEnum = {

    PUT_ON_HOLD: 'PUT_ON_HOLD' as HoldUpgradeOperationEnum,

    CLEAR_ON_HOLD: 'CLEAR_ON_HOLD' as HoldUpgradeOperationEnum
};

